import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { getBitacora } from '../../actions/BitacoraAction'
import Pagination from '../pagination/Pagination'
import moment from 'moment'
import { Timeline, Spin } from 'antd'

export class Bitacora extends Component {

  constructor(props) {
    super(props)

    this.state = {
      activePage: 1
    }
  }

  componentDidMount() {
    const { activePage } = this.state
    this.props.getBitacora(activePage)
  }

  handleChangePage = page => {
    this.setState({
      activePage: page
    }, () => {
      this.props.getBitacora(page)
    })
  }

  render() {
    const { activePage } = this.state
    const { data, headers, isFetching } = this.props

    return (<React.Fragment>
      {isFetching && <Spin />}
      {!isFetching && <Timeline mode="alternate">
        {data && data.map((r, k) => {
          return <Timeline.Item key={k}>{r.action}, {moment(r.createdAt).format("DD/MM/YYYY HH:mm:ss")} Hrs</Timeline.Item>
        })}
      </Timeline>}
      <Pagination
        keyCollection='bitacora'
        useStyle={false}
        defaultPageSize={10}
        handleChangePage={this.handleChangePage}
        activePage={activePage}
        headers={headers} />
    </React.Fragment>)
  }
}

const mapStateToProps = state => {
  return {
    data: state.bitacora.data,
    headers: state.bitacora.headers,
    isFetching: state.bitacora.isFetching,
  }
}

const mapDispatchToProps = {
  getBitacora
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Bitacora)))